export default __webpack_public_path__ + "static/media/Equipements-de-stationnement.62b1ae78.jpg";